import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { fetchPreloanForm } from '../../../../services/preloanFormApi';
import PDFPreview from '../../../Cotizador/PDFComponent/PDFPreview';
import { Loader } from '../../../../Components';

const PDFModal = ({ visible, onHide, personaId, type }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [pdfData, setPdfData] = useState(null);

    useEffect(() => {
        const loadPDFData = async () => {
            if (!visible || !personaId || !type) return;

            setLoading(true);
            setError(null);
            setPdfData(null);

            try {
                const data = await fetchPreloanForm(personaId, type);
                setPdfData(data);
            } catch (err) {
                console.error('Error fetching PDF data:', err);
                setError('Error al cargar los datos del contrato. Por favor intente nuevamente.');
            } finally {
                setLoading(false);
            }
        };

        loadPDFData();
    }, [visible, personaId, type]);

    const handleHide = () => {
        setPdfData(null);
        setError(null);
        onHide();
    };

    return (
        <Dialog
            visible={visible}
            onHide={handleHide}
            header="Vista Previa del Contrato"
            style={{ width: '70vw', height: '60vh' }}
            maximizable
            modal
        >
            {loading && (
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100%' 
                }}>
                    <Loader msg="Cargando PDF..."/>
                </div>
            )}

            {error && (
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100%',
                    color: '#dc2626',
                    fontSize: '16px'
                }}>
                    {error}
                </div>
            )}

            {!loading && !error && pdfData && (
                <div style={{ width: '100%', height: '100%' }}>
                    <PDFPreview data={pdfData} type={type} />
                </div>
            )}
        </Dialog>
    );
};

export default PDFModal;
